import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'Difference',
    href: '#difference'
  }, {
    name: 'Prices',
    href: '#pricing'
  }, {
    name: 'How it works',
    href: '#how-it-works'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-paper/90 backdrop-blur-xl border-b border-concrete/30 py-4' : 'bg-transparent py-8'}`} data-id="element-146">
      <div className="container mx-auto px-8 lg:px-12 flex items-center justify-between" data-id="element-147">
        <a href="#" className="block w-28 md:w-32" data-id="element-148">
          <img src="https://cdn.magicpatterns.com/uploads/3iWP1S9hRbXKSgqthcd4fE/PNG_Logos_for_Nitido_Pro_1_1.png" alt="NÍTIDO PRO" className="w-full h-auto transition-all duration-500" data-id="element-149" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-10" data-id="element-150">
          {navLinks.map(link => <a key={link.name} href={link.href} className={`text-xs uppercase tracking-[0.2em] transition-colors duration-300 ${isScrolled ? 'text-ink/60 hover:text-ink' : 'text-paper/80 hover:text-paper'}`} data-id="element-151">
              {link.name}
            </a>)}
          <a href="#quote" className={`px-6 py-3 text-xs uppercase tracking-[0.2em] transition-all duration-300 border ${isScrolled ? 'border-ink text-ink hover:bg-ink hover:text-paper' : 'border-paper text-paper hover:bg-paper hover:text-ink'}`} data-id="element-152">
            Get a Free Quote
          </a>
        </nav>

        {/* Mobile Toggle */}
        <button className={`md:hidden p-2 transition-colors ${isScrolled ? 'text-ink' : 'text-paper'}`} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-153">
          {isMobileMenuOpen ? <X size={24} strokeWidth={1.5} data-id="element-154" /> : <Menu size={24} strokeWidth={1.5} data-id="element-155" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-156">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} className="absolute top-full left-0 right-0 bg-paper border-b border-concrete/30 shadow-2xl md:hidden" data-id="element-157">
            <div className="flex flex-col px-8 py-10 gap-6" data-id="element-158">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-ink/70 hover:text-ink transition-colors text-sm uppercase tracking-[0.2em]" data-id="element-159">
                  {link.name}
                </a>)}
              <a href="#quote" onClick={() => setIsMobileMenuOpen(false)} className="mt-4 border border-ink text-ink px-6 py-4 text-xs uppercase tracking-[0.2em] text-center hover:bg-ink hover:text-paper transition-colors" data-id="element-160">
                Get a Free Quote
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}